module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_8019.b02d0989.png";